export default __webpack_public_path__ + "static/media/tsi_deepak_tek.06ae0284.png";